'use client';

import { useEffect, useRef } from 'react';
import {
    clearPageContext,
    type PageContextData,
    setPageContext,
} from '../utils/page-context-registry';

/**
 * Registers structured page context data for the floating assistant.
 */
export function useRegisterPageContext(data: PageContextData): void {
    const versionRef = useRef<number>(0);

    useEffect(() => {
        versionRef.current = setPageContext(data);
        return () => clearPageContext(versionRef.current);
    }, [data]);
}
